import { gql } from '@apollo/client';

export const GET_DEPT_DETAIL_BY_ID = gql`
  query GetDeptDetailById($id: Long!) {
    getDeptDetailById(id: $id) {
      success
      message
      data {
        id
        name
        parentId
        warehouseList
        createdAt
        updatedAt
      }
    }
  }
`;

export interface GetDeptDetailByIdResponse {
  getDeptDetailById: {
    success: boolean;
    message: string;
    data?: {
      id?: number | string;
      name?: string;
      parentId?: number | string | null;
      warehouseList?: number[];
    } | null;
  };
}
